const InfoIcon = (props) => {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4143 14C8.32096 14 8.24163 13.9673 8.1763 13.902C8.11096 13.8367 8.0783 13.7573 8.0783 13.664V7.056C8.0783 6.96267 8.11096 6.88333 8.1763 6.818C8.24163 6.75267 8.32096 6.72 8.4143 6.72H9.5763C9.67896 6.72 9.7583 6.75267 9.8143 6.818C9.87963 6.88333 9.9123 6.96267 9.9123 7.056V13.664C9.9123 13.7573 9.87963 13.8367 9.8143 13.902C9.7583 13.9673 9.67896 14 9.5763 14H8.4143ZM8.3583 5.516C8.25563 5.516 8.17163 5.488 8.1063 5.432C8.0503 5.36667 8.0223 5.28267 8.0223 5.18V4.172C8.0223 4.07867 8.0503 3.99933 8.1063 3.934C8.17163 3.86867 8.25563 3.836 8.3583 3.836H9.6323C9.73496 3.836 9.81896 3.86867 9.8843 3.934C9.94963 3.99933 9.9823 4.07867 9.9823 4.172V5.18C9.9823 5.28267 9.94963 5.36667 9.8843 5.432C9.81896 5.488 9.73496 5.516 9.6323 5.516H8.3583Z"
        fill="#D92644"
      />
      <circle cx="9" cy="9" r="8" stroke="#D92644" strokeWidth="2" />
    </svg>
  )
}

export default InfoIcon
